<template>
  <DataTable
    v-redirect-if-no-permission:TYPES
    v-if="name"
    :url="api.ACTIONS.CAR_BRAND_MODELS(id)"
    :title="$t('drivers.carBrandModels.pageTitle', { name: $route.query.name || $t('drivers.carBrandModels.unknown') })"
    :fieldsHiddenMain="['deleted_at']"
    :fieldsHiddenAdd="['id', 'deleted_at', 'created_at', 'updated_at']"
    :fieldsDisabledEdit="['id', 'deleted_at', 'created_at', 'updated_at']"
    :fieldsExtraAdd="{ name: 'v-text-field', number_of_seats: 'v-text-field' }"
    :titles="titles"
  ></DataTable>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";

export default {
  name: "CarBrandModels",
  title() {
    return this.$t("drivers.carBrandModels.title");
  },
  components: { DataTable },
  data() {
    return {
      name: null,
      id: null,
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    this.name = this.$route.query.name || "Unknown";
  },
  computed: {
    titles() {
      return {
        id: "#",
        number_of_seats: this.$t("drivers.carBrandModels.numberOfSeats"),
        name: this.$t("common.name"),
        created_at: this.$t("drivers.carBrandModels.dateCreated"),
        updated_at: this.$t("drivers.carBrandModels.dateUpdated"),

      };
    },
  },
};
</script>

<style scoped></style>
